import React from 'react';

import Header from '../../layout/Header.jsx';
import ListRaces from '../../lists/ListRaces.jsx';

const PageRacesList = () => (
  <div>
    <Header>Races</Header>
    <ListRaces />
  </div>
);

export default PageRacesList;
